import React from "react";
import BottomNav from "../BottomNav";

const BottomNavLayout = (props) => {
  return (
    <div>
      <BottomNav />
      {props.children}
    </div>
  )
}

export default BottomNavLayout;